const modifyRetractionRequest = function ({ commit }, { id, field, value }) {
  commit("UPDATE_RETRACTION_REQUEST", { id, field, value });
};

export default modifyRetractionRequest;
